<template>
  <v-card>
    <v-spacer></v-spacer>
    <v-toolbar
        elevation="1"
        color="#BC0000"
        dark
    >
      <v-card-title class="d-flex justify-center pt-1">
        <h3 class="text-center">Editar estoque da revenda</h3>
      </v-card-title>

      <v-btn color="#ccc" icon @click="close">
        <v-icon size="22">mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card class="pa-4" elevation="0">
      <div class="variation-header">Atributos</div>

      <v-row class="ma-0" v-for="(sku, i) in skus" :key="i" align="end">
        <v-col
            class="d-flex"
            v-for="(attr, idx) in sku.attributes"
            :key="idx"
        >
          <div v-if="attr.attribute.type === 'Cor'" class="mr-4">
            <div :style="switchStyle(attr.hex)"/>
          </div>

          <div>
              <span class="variation-name">
                {{ attr.attribute.name }}
              </span>
            <br/>
            {{ attr.name }}
          </div>
        </v-col>

        <v-col>
          <span class="variation-name"> Preço de venda </span>
          <br/>
          <span class="value-column">
              R$ {{ sku.differentValue.toLocaleString() }}
            </span>
        </v-col>

        <v-col>
          <span class="variation-name"> SKU </span>
          <br/>
          {{ sku.sku }}
        </v-col>

        <v-col class="d-flex flex-column align-center">
          <span class="variation-name mb-3"> Quantidade </span>
          <div class="d-flex px-1">
            <v-text-field
                type="number"
                v-mask="'######'"
                style="width: 200px !important"
                outlined
                dense
                hide-details
                :key="quantityKey"
                v-model="sku.quantity"
            >
            </v-text-field>
          </div>
        </v-col>

        <v-col cols="12">
          <v-divider></v-divider>
        </v-col>
      </v-row>

      <v-row class="ma-0" justify="end">
        <v-col cols="12" sm="6" md="6" lg="6">
          <v-btn
              height="47"
              block
              width="100%"
              class="history-button"
              elevation="0"
              @click="close()"
          >
            Cancelar
          </v-btn>
        </v-col>

        <v-col cols="12" sm="6" md="6" lg="6">
          <v-btn
              height="47"
              block
              width="100%"
              class="add-button"
              elevation="0"
              @click="add"
          >
            Editar estoque
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-card>
</template>

<style scoped>
.history-button {
  border: 2px solid #2d3038;
  box-sizing: border-box;
  font-size: 18px;
  font-weight: bold;
  border-radius: 5px;
  color: #000000!important;
  transition: 0.3s;
  background: transparent!important;
}

.history-button:hover {
  color: #fff !important;
  background: #000000 !important;
  border-radius: 4px;
}

.variation-header {
  display: flex;
  align-items: center;

  padding-left: 20px;

  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.15px;
  color: #979797;

  background: #f5f5f5;
  border-radius: 4px;
  width: 100%;
  height: 70px;
}

.variation-name {
  font-weight: bold;
  font-size: 15px;
  line-height: 0px;
  letter-spacing: 0.15px;
  color: #979797;
}

.value-column {
  font-weight: 300;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.15px;
  color: #9c9c9c;
}

.main-footer {
  background: #ffffff !important;
  box-shadow: 0px -3px 20px rgba(45, 48, 56, 0.1) !important;
  border-radius: 6px !important;
  position: fixed;
}

.add-button {
  background: #bc0000 !important;
  border-radius: 5px;
  font-weight: bold;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #ffffff;

  transition: 0.3s;
}

.add-button:hover {
  background: #e8161e !important;
}
</style>

<script>
import ApiService from "../../../../services/ApiService";

export default {
  name: "EditResaleStock",
  props: {
    resaleproductskuFilter: {
      type: Object,
      required: false,
      default: null
    }
  },
  async created() {
    this.env_url = process.env.VUE_APP_BASE_URL;
    this.filter.productId = this.resaleproductskuFilter.productId;
    this.filter.userId = this.resaleproductskuFilter.userId;
    await this.getProduct()
  },

  data: () => ({
    skus: [],
    originalSkus: [],
    resaleSkus: [],
    product: {},
    env_url: "",
    loading: false,
    apiService: new ApiService(),
    filter: {
      page: 1,
      pageSize: 15,
      productId: null,
      userId: null,
    },
    quantityKey: false,
  }),

  methods: {
    close(){
      this.$emit('close')
    },

    add() {
      this.loading = true;

      let addedSkus = this.skus
          .filter((x) => x.quantity != null)
          .map((x) => ({
            productSkuId: x.id,
            quantity: x.quantity,
            minimumStock: 0,
            resaleId: this.resaleproductskuFilter.resaleId,
            doneByAdminOrMasterUser: true,
          }));
      if (addedSkus.length > 0) {
        this.apiService
            .post("resaleproductsku/addlist", addedSkus)
            .then(() => {
              this.$toast.success("Estoque atualizado com sucesso");
              this.loading = false;
              this.close()
            })
            .catch(() => {
              this.loading = false;
            });
      } else {
        this.$toast.error("Adicione a quantidade a pelo menos um SKU");
      }

      this.loading = false;
    },

    switchStyle(color, menu) {
      return {
        border: "2px dashed #DADADA",
        boxSizing: "border-box",
        backgroundColor: color,
        cursor: "pointer",
        height: "52px",
        width: "56px",
        margin: "0 auto 0 auto",
        borderRadius: menu ? "50%" : "10px",
        transition: "border-radius 200ms ease-in-out",
      };
    },

    async getProduct() {
      this.loading = true;
      await this.apiService
          .post(`productsku/getbyproduct`, this.filter)
          .then((response) => {
            this.skus = response.content.filter((x) => !x.delete_at && x.id == this.resaleproductskuFilter.productSkuId);
            this.originalSkus = response.content.filter((x) => x.isActive === true);
            this.resaleSkus = response.content2;
            this.colorToFirst();
            this.intersectArrays();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
    },

    intersectArrays() {
      this.resaleSkus.forEach((sku) => {
        let finded = this.skus.find((x) => x.id == sku.productSkuId);

        if (finded != null) {
          finded.quantity = sku.quantity;
          finded.minimumStock = sku.minimumStock;
        }
      });
    },

    colorToFirst() {
      this.skus.map((sku) => {
        let findColor = [];

        sku.quantity = 0;

        findColor = sku.attributes.filter((x) => x.attribute.type === "Cor");

        if (findColor.length > 0) {
          findColor.map((color) => {
            let idx = sku.attributes.findIndex((y) => y == color);
            sku.attributes.splice(0, 0, sku.attributes.splice(idx, 1)[0]);
          });
        }
      });
    },
  },
};
</script>
